'use client'

import Input from '@components/primitives/Input'
import { Text } from '@components/primitives/Text'
import { UnitConversion } from '@lib/utilities/UnitConversion'
import { useEffect, useRef, useState } from 'react'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { DemographicsCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified('weightInKg')

export default function CollectWeight({
  patientProfileData: { weightInKg },
}: DemographicsCollectElementProps) {
  const customRef = useRef<HTMLInputElement>(null)
  const [currentValue, setCurrentValue] = useState(weightInKg[0])

  const lbs = weightInKg[0]
    ? UnitConversion.kilogramsToPounds(parseInt(weightInKg[0])).toString()
    : undefined

  const handleWeightChange = (newWeight: string) => {
    const lbs = parseInt(newWeight)
    const newWeightInKg = UnitConversion.poundsToKilograms(lbs).toString()
    setCurrentValue(newWeightInKg)
    debouncedEventTracking(newWeightInKg)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (customRef.current) {
        customRef.current.focus()
        customRef.current.type = 'text'
        customRef.current.setSelectionRange(-1, -1)
        customRef.current.type = 'number'
      }
    }, 500)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <div className='mx-auto flex w-max flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='How much do you weigh?'
      />
      <div className='flex flex-col gap-2'>
        <Text
          className='text-neutral900'
          element={'p'}
          styleName='p-small'
          value='Pounds'
        />
        <Input
          className='h-14 w-full rounded-md border-neutral200 bg-neutral50 text-neutral900'
          defaultValue={lbs}
          innerRef={customRef}
          inputMode='numeric'
          max={999}
          min={0}
          onChange={(e) => handleWeightChange(e.target.value)}
          placeholder='lbs'
          type='number'
        />
        <input name='weightInKg' type='hidden' value={currentValue} />
      </div>
    </div>
  )
}
